import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { OtherUseService } from '../proxy/planning/controllers/other-use.service';
import { RegisterService } from '../proxy/planning/controllers/register.service';

FieldBuilder.setNamespace('Planning');

export const OTHERUSEPERREGISTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('otherUseId', 'Entity.OtherUse', OtherUseService)
    .required()
    .displayFromNested('otherUse.name')
    .sortBy('otherUse.name')
    .readOnly()
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('registerId', 'Entity.Register', RegisterService)
    .required()
    .displayFromNested('register.name')
    .sortBy('register.name')
    .readOnly()
    .build(),
  FieldBuilder
    .number('gisOtherUseRegisterArea', 'Entity.OtherUsePerRegister.GisOtherUseRegisterArea')
    .decimal(2,10)
    .readOnly()
    .build(),
  FieldBuilder
    .number('registerAreaCorrection', 'Entity.OtherUsePerRegister.RegisterAreaCorrection')
    .decimal(2,10)
    .readOnly()
    .build(),
  FieldBuilder
    .number('otherUseRegisterArea', 'Entity.OtherUsePerRegister.OtherUseRegisterArea')
    .required()
    .decimal(2,10)
    .readOnly()
    .build(),
  FieldBuilder
    .number('otherUseAreaPercentage', 'Entity.OtherUsePerRegister.OtherUseAreaPercentage')
    .required()
    .decimal(2,10)
    .readOnly()
    .build(),
  FieldBuilder
    .checkbox('isMainRegister', 'Entity.OtherUsePerRegister.IsMainRegister')
    .readOnly()
    .build(),
  FieldBuilder
    .checkbox('isLastRegister', 'Entity.OtherUsePerRegister.IsLastRegister')
    .readOnly()
    .build(),
];

export const OTHERUSEPERREGISTER_CONFIG = {
  entityName: 'OtherUsePerRegister',
  localizationKey: 'Planning::Entity.OtherUsePerRegister',
  fields: OTHERUSEPERREGISTER_FIELDS,
  permission: 'PlanningLocation.OtherUsePerRegisters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
